import { useEffect } from 'react'

import { mixpanel } from '@/mixpanel'
import { useLoggedInForMandatee } from '@/modules/trust/hooks/useLoggedInForMandatee'
import { isIntramuros } from '@/utils/intramuros'
import { getAnalyticsTaskType } from '../utils/task.utils'

import type { Task } from '../types/task.types'

export function useTrackTaskDetailView({ task }: { task?: Task | null }) {
  const isLoggedInForMandatee = useLoggedInForMandatee()

  useEffect(() => {
    if (!task) return

    const questionnaireSlug = 'questionnaire' in task ? task.questionnaire?.name : undefined

    mixpanel.track('task_detail_view', {
      origin,
      task_type: getAnalyticsTaskType(task),
      status: task.status,
      questionnaire_slug: questionnaireSlug,
      is_mandate: isLoggedInForMandatee,
      isIntramuros,
    })
  }, [task])
}
